import React from "react";
import Section from "../components/layout/Section";
import {
  Typography,
  Box,
  Button,
  Link
} from "@mui/material";

const Contact = () => {
  return (
    <Box sx={{ p: 2.5 }}>
      <Section id="intro" title="Contact Us">
        <Typography
          variant="caption"
          color="secondary"
          sx={{ mt: -1, mb: 2, display: "block" }}
        >
          Last updated: April 2026
        </Typography>
        <Typography paragraph>
          We advise checking our <Link href="/faq">FAQ</Link> first if you haven't already! If your question is still unanswered, the best way to get in contact with our team is to join our discord! After reading and agreeing to the rules, you will have access to the #help channel where anyone can post questions as well as our ticketing system for those who prefer more privacy. Team members are regularly checking the discord and will direct appropriate inquiries to the right person.
        </Typography>

        <Typography paragraph>
          Please also note that our discord server is not a chat server. We post announcements/updates there and the main purpose is for people to be able to use lebronbot to search/report trades or to get help/send feedback regarding our project.
        </Typography>

        <Box sx={{ textAlign: 'center', mt: 3 }}>
          <Button
            size="large"
            href="https://discord.gg/HtpWdxZV4U"
            variant="contained"
          >
            join our discord!
          </Button>
        </Box>
      </Section>
    </Box>
  );
};

export default Contact;
